import { render } from "./9.OurServices.vue?vue&type=template&id=3616a138&scoped=true"
import script from "./9.OurServices.vue?vue&type=script&lang=js"
export * from "./9.OurServices.vue?vue&type=script&lang=js"

import "./9.OurServices.vue?vue&type=style&index=0&id=3616a138&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3616a138"]])

export default __exports__